// extracted by mini-css-extract-plugin
export var standaloneTable = "_el-0";
export var withExtraHeader = "_el-1";